import React, { useEffect, useState } from 'react';
import { Eye, EyeOff, Shield, Smartphone, Lock } from 'react-feather';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Container, Form, Input, InputGroup, InputGroupText, Label, Row, Card, CardBody } from 'reactstrap';
import { AesEncrypt, AesDecrypt, keyPromise } from '../../Service/crypto';
import webservice from '../../Service/webservice';
import api from '../../api';
import { useDispatch } from 'react-redux';
interface FormData {
  mfaCode: string;
}

const defaultValues: FormData = {
  mfaCode: "",
};
interface NavigatorConnection extends Navigator {
  connection?: {
    effectiveType?: string;
    downlink?: number;
  };
}


const Pin = () => {
  const navigate = useNavigate();
  const { handleSubmit, control, setError, formState: { errors } } = useForm<FormData>({ defaultValues });
  const [networkSpeed, setNetworkSpeed] = useState<string | null>(null);
  const [ipData, setIpData] = useState("");
  const [browserName, setBrowserName] = useState("");
  const [osName, setOsName] = useState("");
  const dispatch = useDispatch();
  const [otpEnabled, setOtpEnabled] = useState<boolean>(false);
  const [otpauthUrl, setOtpauthUrl] = useState<string>("");
  const [mfaSecret, setMfaSecret] = useState<string>("");
  const [mfaToken, setMfaToken] = useState<string>("");
  const [showMfaCode, setShowMfaCode] = useState<boolean>(false);
  const [qrCodeImage, setQrCodeImage] = useState<string>("");


// Check OTP status and setup QR code if needed
useEffect(() => {
  const otpEnabledStatus = localStorage.getItem('otp_enabled') === 'true';
  const storedOtpauthUrl = localStorage.getItem('otpauth_url') || '';
  const storedMfaSecret = localStorage.getItem('mfa_secret') || '';
  const storedMfaToken = localStorage.getItem('mfa_token') || '';
  
  setOtpEnabled(otpEnabledStatus);
  setOtpauthUrl(storedOtpauthUrl);
  setMfaSecret(storedMfaSecret);
  setMfaToken(storedMfaToken);
  
  // If OTP not enabled and we have otpauth URL, generate QR code
  if (!otpEnabledStatus && storedOtpauthUrl) {
    generateQRCode(storedOtpauthUrl);
  }
}, []);

const generateQRCode = async (url: string) => {
  try {
    const QRCode = (await import('qrcode')).default;
    const qrDataUrl = await QRCode.toDataURL(url);
    setQrCodeImage(qrDataUrl);
  } catch (error) {
    console.error('Error generating QR code:', error);
  }
};

// Getting ip address start
useEffect(() => {
  const getIp = () => {
    fetch('https://api.ipregistry.co/?key=ira_ArABTHEAuimffyMu5HfiZCI3PaLoBE3hT631')
      .then((response) => response.json())
      .then((data) => {
        setIpData(data.ip);
        setBrowserName(data.user_agent.name);
        setOsName(data.user_agent.os.name);
        const Time =data.time_zone.id
        localStorage.setItem("timezone", Time);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  };
  getIp();
}, []);

// Setting user network speed start
useEffect(() => {
  const calculateNetworkSpeed = () => {
    const navigatorConnection = navigator as NavigatorConnection;
    if (navigatorConnection.connection) {
      const connection = navigatorConnection.connection;
      if (connection.effectiveType) {
        // You might want to use this information as well
      }
      if (connection.downlink) {
        const downlinkSpeed = (connection.downlink * 8).toFixed(2);
        setNetworkSpeed(downlinkSpeed + " Mbps");
      }
    }
  };
  calculateNetworkSpeed();
}, []);

const userloghistory = async (userLoginHistoryData: any) => {
  const key = await keyPromise;
  const EncParams = await AesEncrypt(key, userLoginHistoryData);
  const response = await api.fetch('api/UserlogHistory/Userloginhistory_add', {
    method: 'POST',
    body: JSON.stringify({ EncParams }),
  });
  return await response.json();
};


const Useractivelist = async (useractivelistData: any) => {
  const key = await keyPromise;
  const EncParams = await AesEncrypt(key, useractivelistData);
  const response = await api.fetch('api/ActiveUserList/Useractivelist_add', {
    method: 'POST',
    body: JSON.stringify({ EncParams }),
  });
  return await response.json();
};


const userId = localStorage.id;
const usertype = localStorage.UserType;
const userName = localStorage.UserName;

const onSubmit: SubmitHandler<FormData> = async (data) => {
  // Verify MFA if enabled
  if (otpEnabled) {
    if (!data.mfaCode) {
      setError("mfaCode", { type: "manual", message: "Please enter MFA code" });
      return;
    }

    try {
      const key = await keyPromise;
      const EncParams = await AesEncrypt(key, { 
        userId: localStorage.getItem('id'), 
        mfaCode: data.mfaCode,
        mfaToken: mfaToken 
      });
      
    //   const response = await api.fetch('api/Authentication/verifyMFA', {
    //     method: 'POST',
    //     body: JSON.stringify({ EncParams })
    //   });

      const response = await fetch(webservice + 'api/Authentication/verifyMFA', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        }
      });
      
      const result = await response.json();

      const decryptedData = await AesDecrypt(key, result);
      console.log("decryptedData........", decryptedData);
      
      if (!decryptedData.success) {
        setError("mfaCode", { type: "manual", message: decryptedData.message || "Invalid MFA code" });
        return;
      }

      localStorage.setItem("token", decryptedData["token"] || "");
      localStorage.setItem("refresh_token", decryptedData["refresh_token"] || "");
    } catch (error) {
      console.error("Error verifying MFA:", error);
      setError("mfaCode", { type: "manual", message: "Error verifying MFA code" });
      return;
    }
  } else {
    // First-time MFA setup - enable MFA after verifying code
    if (!data.mfaCode) {
      setError("mfaCode", { type: "manual", message: "Please enter MFA code from your authenticator app" });
      return;
    }

    try {
      const key = await keyPromise;
      const EncParams = await AesEncrypt(key, { 
        userId: localStorage.getItem('id'), 
        mfaCode: data.mfaCode,
        mfaToken: mfaToken 
      });
      
      const response = await fetch(webservice + 'api/Authentication/enableMFA', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        }
      });
      
      const result = await response.json();
      const decryptedData = await AesDecrypt(key, result);

      console.log("decryptedData........first...time", decryptedData);
      
      if (!decryptedData.success) {
        setError("mfaCode", { type: "manual", message: decryptedData.message || "Invalid MFA code" });
        return;
      }

      localStorage.setItem("token", decryptedData["token"] || "");
      localStorage.setItem("refresh_token", decryptedData["refresh_token"] || "");
      
      // Update localStorage to reflect OTP is now enabled
      localStorage.setItem('otp_enabled', 'true');
    } catch (error) {
      console.error("Error enabling MFA:", error);
      setError("mfaCode", { type: "manual", message: "Error enabling MFA" });
      return;
    }
  }

  // Proceed with login
  const username = userName;
  const userid = userId;
  const Usertype = usertype;
  const UserIPAddress = ipData;
  const userBrowser = browserName;
  const userOsName = osName;
  const usernetspeed = networkSpeed;

  try {
    const result = await userloghistory({
      username,
      Usertype,
      userid,
      UserIPAddress,
      userBrowser,
      userOsName,
      usernetspeed,
    });
    const activeListData = await Useractivelist({
      username,
      Usertype,
      userid,
      UserIPAddress,
      userBrowser,
      userOsName,
      usernetspeed,
    });
  
    // Combine result and data into a single object
    const combinedPayload = {
      logHistory: result,
      activeList: activeListData,
    };
  
    dispatch({ type: 'user/loghistory/fulfilled', payload: combinedPayload });
    localStorage.setItem('login', JSON.stringify(true));
    window.dispatchEvent(new CustomEvent('auth_state_changed', { detail: { action: 'login', userId: localStorage.getItem('id') } }));
    navigate(`/dashboard`);
  } catch (error) {
    console.error("Error logging user history:", error);
  }    
};

  return (
    <div className="page-wrapper">
      <Container fluid className="p-0">
        <Row className="m-0">
          <Col xs={12} className="p-0">
            <div className="login-card login-dark">
              <div>
                <div className="login-main">
                  <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
                    {/* Header Section */}
                    <div className="text-center mb-2">
                      <div className="mb-1">
                        <Shield size={40} className="text-primary" />
                      </div>
                      <h4 className="mb-2">Two-Factor Authentication</h4>
                      <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                        {otpEnabled 
                          ? "Enter the verification code from your authenticator app" 
                          : "Secure your account with two-factor authentication"}
                      </p>
                    </div>

                    {/* QR Code Section - Only for first-time setup */}
                    {!otpEnabled && qrCodeImage && (
                      <Card className="mb-2" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                        <CardBody className="text-center p-3">
                          <div className="mb-1">
                            <Smartphone size={28} className="text-primary" />
                          </div>
                          <h6 className="mb-1" style={{ fontSize: '15px' }}>Scan QR Code</h6>
                          <p className="text-muted small mb-2" style={{ fontSize: '12px' }}>
                            Scan the QR Code below using your preferred authenticator app
                          </p>
                          <div className="d-flex justify-content-center mb-2">
                            <div 
                              style={{ 
                                backgroundColor: 'white',
                                padding: '6px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                              }}
                            >
                              <img 
                                src={qrCodeImage} 
                                alt="MFA QR Code" 
                                style={{ 
                                  width: '180px',
                                  height: '180px',
                                  display: 'block'
                                }}
                              />
                            </div>
                          </div>
                          <p className="text-muted small mb-0" style={{ fontSize: '11px' }}>
                            Compatible with Google Authenticator, Microsoft Authenticator, Authy, and more
                          </p>
                        </CardBody>
                      </Card>
                    )}

                    {/* Divider for first-time setup */}
                    {!otpEnabled && qrCodeImage && (
                      <div className="d-flex align-items-center my-3">
                        <hr className="flex-grow-1" style={{ borderColor: '#dee2e6' }} />
                        <span
                          className="mx-2"
                          style={{ 
                            fontSize: "10px", 
                            fontWeight: 600, 
                            color: "#6c757d",
                            letterSpacing: '1px'
                          }}
                        >
                          THEN ENTER CODE
                        </span>
                        <hr className="flex-grow-1" style={{ borderColor: '#dee2e6' }} />
                      </div>
                    )}

                    {/* Code Input Section */}
                    <div className="mb-3">
                      <Label className="mb-2" style={{ fontWeight: 500, fontSize: '14px' }}>
                        <Lock size={14} className="me-2" />
                        {otpEnabled ? 'Verification Code' : 'Enter Code from Authenticator'}
                        <span className="text-danger"> *</span>
                      </Label>
                      <Controller
                        name="mfaCode"
                        control={control}
                        render={({ field }) => (
                          <InputGroup>
                            <Input
                              type={showMfaCode ? "text" : "password"}
                              required
                              placeholder="000000"
                              invalid={errors.mfaCode && true}
                              maxLength={6}
                              style={{
                                fontSize: '16px',
                                letterSpacing: '3px',
                                textAlign: 'center',
                                fontWeight: 500,
                                padding: '10px'
                              }}
                              {...field}
                            />
                            <InputGroupText 
                              onClick={() => setShowMfaCode(!showMfaCode)}
                              style={{ cursor: 'pointer' }}
                            >
                              {showMfaCode ? <EyeOff size={16} /> : <Eye size={16} />}
                            </InputGroupText>
                          </InputGroup>
                        )}
                        rules={{ required: 'Please enter MFA code' }}
                      />
                      {errors.mfaCode && (
                        <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                          <small>{errors.mfaCode.message}</small>
                        </div>
                      )}
                      {!errors.mfaCode && (
                        <small className="text-muted d-block mt-1" style={{ fontSize: '12px' }}>
                          Enter the 6-digit code from your authenticator app
                        </small>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="mt-3">
                      <Button 
                        color="primary" 
                        className="btn-block w-100" 
                        style={{ fontWeight: 500 }}
                      >
                        {otpEnabled ? 'Verify & Continue' : 'Enable MFA & Continue'}
                      </Button>
                    </div>

                    {/* Info Section */}
                    {!otpEnabled && (
                      <div className="mt-3 p-2" style={{ 
                        backgroundColor: '#e7f3ff', 
                        borderRadius: '6px',
                        border: '1px solid #b3d9ff'
                      }}>
                        <small className="text-muted d-block" style={{ lineHeight: '1.5', fontSize: '11px' }}>
                          <strong>Note:</strong> After scanning the QR code, your authenticator app will generate a new code every 30 seconds. Enter the current code to complete setup.
                        </small>
                      </div>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Pin;
